import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function LaunchTimelinesRegions({ launchTimelinesAndRegions }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     upcoming_launches: "b",
  //     launch_window: "c",
  //     target_regions: "d",
  //     upcoming_launches_positive_insight: "b",
  //     upcoming_launches_negative_insight: "b",
  //     upcoming_launches_recent_development: "b",
  //     launch_window_positive_insight: "c",
  //     launch_window_negative_insight: "c",
  //     launch_window_recent_development: "c",
  //     target_regions_positive_insight: "d",
  //     target_regions_negative_insight: "d",
  //     target_regions_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     upcoming_launches: "b",
  //     launch_window: "c",
  //     target_regions: "d",
  //     upcoming_launches_positive_insight: "b",
  //     upcoming_launches_negative_insight: "b",
  //     upcoming_launches_recent_development: "b",
  //     launch_window_positive_insight: "c",
  //     launch_window_negative_insight: "c",
  //     launch_window_recent_development: "c",
  //     target_regions_positive_insight: "d",
  //     target_regions_negative_insight: "d",
  //     target_regions_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     upcoming_launches: "b",
  //     launch_window: "c",
  //     target_regions: "d",
  //     upcoming_launches_positive_insight: "b",
  //     upcoming_launches_negative_insight: "b",
  //     upcoming_launches_recent_development: "b",
  //     launch_window_positive_insight: "c",
  //     launch_window_negative_insight: "c",
  //     launch_window_recent_development: "c",
  //     target_regions_positive_insight: "d",
  //     target_regions_negative_insight: "d",
  //     target_regions_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(launchTimelinesAndRegions);
    setTabData(tableData);
  }, [launchTimelinesAndRegions]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "upcoming_launches", label: "Upcoming Launches" },
    { key: "launch_window", label: "Launch Window" },
    { key: "target_regions", label: "Target Regions" },
  ];

  return (
    <InsightTable
      title="Launch Timelines & Regions"
      subtitle="A comparative view of major product launches in the pipeline, expected timelines, and targeted geographic rollouts across competitors."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default LaunchTimelinesRegions;
